var Utils = (function() {
  'use strict';

  var inBounds = function(point, bounds) {

    var lng = (point.lng - bounds._ne.lng) * (point.lng - bounds._sw.lng) < 0;
    var lat = (point.lat - bounds._ne.lat) * (point.lat - bounds._sw.lat) < 0;

    return lng && lat;
  };

  return {
    inBounds: inBounds,

    isMobileOrTablet: function() {
      return navigator.userAgent.match(/Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile/);
    },

    convertFrenchDateToIso: function(d) {
      var dateArray = d.split("/");
      return dateArray[2] + '-' + dateArray[1] + '-' + dateArray[0];
    }
  };

}());
